export default __webpack_public_path__ + "static/media/whale-sunset.20fdde3ffad66a7da45940d714fa11cd.jpg";